import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReviewReasonComponent } from 'src/app/admin/components/review-reason/review-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-admin-network-eco',
  templateUrl: './admin-network-eco.component.html',
  styleUrls: ['./admin-network-eco.component.css'],
})
export class AdminNetworkEcoComponent implements OnInit {
  updateForm: FormGroup;
  private getApi = environment.url + environment.networkGet;
  private updateStatusApi = environment.url + environment.updateStatus;
  /**
   * Constructs an instance of the AdminNetworkEcoComponent.
   * @param changeDetectorRef Reference to Angular's change detector for triggering change detection.
   * @param media Service to match media queries for responsive design.
   * @param getdata Service to retrieve values or data needed by the component.
   * @param fb FormBuilder service for creating reactive forms.
   * @param makeapi Service for making API calls.
   * @param dialog Material dialog service for opening dialogs.
   * @param notify Service for displaying notifications.
   * @param appCom Reference to the root AppComponent.
   * @param http Angular HttpClient for HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private getdata: ValueService,
    private fb: FormBuilder,
    private makeapi: ApiService,
    public dialog: MatDialog,
    private notify: NotifyService,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    /**
     * Initializes the update form with the incubatorId control.
     * The form group is used to store the incubatorId that is needed to make API calls.
     */
    this.updateForm = this.fb.group({
      incubatorId: [''],
    });

    /**
     * Initializes the mobile query to detect when the screen size is below 992px.
     * The mobile query is used to show or hide the side nav based on the screen size.
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');

    /**
     * Initializes the event listener to detect changes in the mobile query.
     * When the mobile query changes, it triggers change detection.
     */
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  /**
   * Lifecycle hook that is called after the component is initialized.
   * It removes the event listener for the mobile query.
   */
  ngAfterViewInit(): void {
    // Remove the event listener to prevent memory leaks
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  incubaterName;
  /**
   * Angular lifecycle hook that is called after the component is initialized.
   * It retrieves the incubator name and ID from session storage, updates the form,
   * fetches data from the API, and retrieves guideline data.
   */
  ngOnInit(): void {
    // Retrieve the incubator name from session storage and assign it to the component property
    this.incubaterName = sessionStorage.getItem('adminIncubName');

    // Get the current form values and update the incubator ID from session storage
    let getform = this.updateForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');

    // Update the form with the modified values
    this.updateForm.patchValue(getform);

    // Fetch data from the API
    this.getDataApi();

    // Retrieve guideline data
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches data from the API using the incubator ID from session storage,
   * shows a loading indicator during the request, and updates the component's
   * data on success.
   */
  getDataApi() {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Make the API request
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        // Hide the loading indicator and update the component's data
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
      });
  }
  /**
   * Returns the color associated with the given value by delegating to the
   * `questionStatus` method of `getdata`.
   *
   * @param val - The value for which the color is to be determined.
   * @returns The color corresponding to the provided value.
   */
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  /**
   * Returns the status name for the given value using the getdata service.
   * @param val - The value to retrieve the status name for.
   * @returns The status name corresponding to the provided value.
   */
  innerValue(val: number): string {
    return this.getdata.StatusName(val);
  }
  /**
   * Downloads a PDF file.
   * @param value - The URL of the PDF to download.
   */
  download(value: string) {
    const pdfUrl = value;
    const pdfName = 'your_pdf_file.pdf';
    // Use the FileSaver library to download the PDF
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  /**
   * Approves an item by adding a control to the form, submitting the update, and handling the response.
   * @param keys - The key to add as a control in the form.
   * @param id - The value to set for the added control.
   */
  approveBtn(keys, id) {
    // Add the key as a control in the form, and set its value to the provided id
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);

    // Show a loading indicator until the request is complete
    this.getdata.amizhthLoader('show');

    // Get the current form values
    let getform = this.updateForm.value;

    // Submit the form with the updated values
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        // Hide the loading indicator once the request is complete
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // If the request was successful, notify the user of success
          this.notify.notifysuccess(data.responseMessage);
          // Remove the control from the form
          this.updateForm.removeControl(keys);
          // Refresh the data
          this.getDataApi();
        } else {
          // If the request was not successful, notify the user of an error
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Submits the rejection reason for the given keys and id.
   * Adds the rejection reason to the form and submits the form with the updated values.
   * On success, removes the control from the form and refreshes the data.
   *
   * @param keys - The keys to add as a control to the form
   * @param id - The value to set for the added control
   */
  rejectBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.updateForm.removeControl(keys);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Opens the ReviewReasonComponent dialog to review an item.
   * Refreshes the data after the dialog is closed.
   *
   * @param key - The unique identifier for the item to review.
   * @param status - The current status of the item.
   */
  reviewBtn(key, status) {
    // Open the ReviewReasonComponent dialog with the specified key and status
    const dialogRef = this.dialog.open(ReviewReasonComponent, {
      width: '390px',
      data: { _key: key, _status: status },
    });

    // Subscribe to the dialog's afterClosed observable to refresh data
    dialogRef.afterClosed().subscribe((result) => {
      this.getDataApi(); // Refresh the data
    });
  }
  /**
   * Opens the guidelines modal for the given data
   * @param data - The data for which the guidelines modal should be opened
   */
  guidelinesBtn(data) {
    // Open the guidelines modal with the given data
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  /**
   * Retrieves the guidelines data from the JSON file
   */
  guidelineDatas() {
    // Get the guidelines data from the JSON file
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      // Set the guidelines value to the questions array in the data
      this.guidelineValue = data[5].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
}
